import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';

const initialState = {
    status: null,
    paymentRequest: {},
    transactions: [],
    spinner: true,
    paid: 0
};

const updateTransactions = (state, {body}) => {
    if(state.transactions.length > 0) {
        const findIndex = state.transactions.findIndex(({id}) => id === body.id);
        if(findIndex >= 0) { // find an exist transaction object
            const newTransactions = [...state.transactions];
            newTransactions[findIndex] = body;
            return updateObject(state, {transactions: newTransactions});
        }

        // add new transaction 
        return updateObject(state, {transactions: [...state.transactions, body]});
    }

    // set transactions
    return updateObject(state, {transactions: Array.isArray(body) ? body : [body]});
}

const setPaymentRequest = (state, {paymentRequest}) => {
    return updateObject(state, {paymentRequest})
}

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.UPDATE_TRANSACTIONS:
            return updateTransactions(state, action)
        case actionTypes.SET_PAYMENT_REQUEST:
            return setPaymentRequest(state, action)
        default:
            return state;
    }
};

export default reducer;